import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { getThemeDiscussionPalette } from '../../config/themes';

export default function IdeaReferencePicker({ items, activeIndex, onActiveIndex, onChoose, anchor, theme, isDarkMode, listId }) {
  const activeRef = useRef(null);
  useEffect(() => activeRef.current?.scrollIntoView({ block: 'nearest' }), [activeIndex]);
  const palette = getThemeDiscussionPalette(theme, isDarkMode);
  const rect = anchor?.getBoundingClientRect();
  if (!rect) return null;
  const width = Math.min(340, window.innerWidth - 16);
  const below = window.innerHeight - rect.bottom >= 200;
  return createPortal(
    <div data-export-ignore="true" onPointerDown={event => event.stopPropagation()} onMouseDown={event => { event.preventDefault(); event.stopPropagation(); }} onClick={event => event.stopPropagation()}
      style={{ position: 'fixed', zIndex: 1100, left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8)),
        ...(below ? { top: rect.bottom + 8 } : { bottom: window.innerHeight - rect.top + 8 }), width,
        maxHeight: 280, overflowY: 'auto', border: `1px solid ${palette.border}`, borderRadius: 12,
        background: palette.panel, color: palette.text, boxShadow: '0 8px 24px rgba(0,0,0,.25)', padding: 4 }}>
      <div role="listbox" id={listId} aria-label="Link to an idea">
        {items.map((item, index) => <div key={item.id} id={`${listId}-${index}`} role="option" aria-selected={index === activeIndex}
          ref={index === activeIndex ? activeRef : undefined} onMouseEnter={() => onActiveIndex(index)} onClick={() => onChoose(item)}
          style={{ padding: '8px 10px', borderRadius: 8, cursor: 'pointer', background: index === activeIndex ? palette.raised : 'transparent' }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>#{item.label}</div>
          <div style={{ fontSize: 11, opacity: .65, marginTop: 3 }}>{item.path || 'Main idea'}</div>
        </div>)}
      </div>
      {!items.length && <div role="status" style={{ padding: 10, fontSize: 13 }}>No matching ideas</div>}
    </div>, document.body
  );
}
